// lib
import { connect } from "react-redux";
import * as R from "ramda";

// src
import { PresetType } from "config/constants";
import Component from "components/plannings/partials/presetPicker/PresetPicker";
import { strictJoin } from "utils/presets";
import {
  disableCategory,
  enableCategory,
  disablePreset,
  enablePreset,
} from "actions/presets/thunks";
import { showFavorites, showSearch } from "actions/ux";
import { selfTranslate } from "i18n/proxy";

const fromIndexToGroups = (index, categories) =>
  R.sort(
    (g1, g2) => g1.parent.id - g2.parent.id,
    R.values(
      R.mapObjIndexed(
        (group, key) => ({
          parent: R.find(({ id }) => id.toString() === key, categories),
          children: group,
        }),
        index,
      ),
    ),
  );

const mapStateToProps = ({
  presets: { byId, categories, localIds, favoriteIds, popularIds, enabledIds },
  system: { idleSince },
  user: { isLogged },
  ux: { language },
}) => {
  const filteredLocalIds = R.difference(localIds, favoriteIds);
  const filteredPopularIds = R.difference(popularIds, [...favoriteIds, ...filteredLocalIds]);
  const qualify = strictJoin(byId);

  // Create favorite groups
  const favorites = qualify(favoriteIds).map((p, index) => ({ ...p, index }));
  const { floor, ...parentedIndex } = R.groupBy((p) => p.underId || "floor", favorites);
  const favoritesFloor = R.filter((p) => p.type !== PresetType.CATEGORY, floor || []);
  // filtering is a a security belt
  const favoritesGroups = R.sort(
    (g1, g2) => g1.parent.index - g2.parent.index,
    R.filter(
      (group) => Boolean(group.parent),
      R.values(
        R.mapObjIndexed(
          (group, key) => ({
            parent: R.find(({ id }) => id === key, floor || []),
            children: group,
          }),
          parentedIndex,
        ),
      ),
    ),
  );
  // Create popular groups

  const populars = qualify(filteredPopularIds);
  const coursesIndex = R.groupBy(
    (p) => p.categoryId,
    R.filter(({ categoryId }) => categoryId <= 3, populars),
  );
  const roomsIndex = R.groupBy(
    (p) => p.categoryId,
    R.filter(({ categoryId }) => categoryId > 3, populars),
  );
  const coursesGroups = fromIndexToGroups(coursesIndex, categories);
  const roomsGroups = fromIndexToGroups(roomsIndex, categories);

  return {
    isIdle: Boolean(idleSince),
    isLogged,
    locals: qualify(filteredLocalIds),
    favoriteIds,
    favorites,
    favoritesFloor,
    favoritesGroups,
    coursesGroups,
    roomsGroups,
    enableds: qualify(enabledIds),
    selfTranslate: (name) => selfTranslate(name, language),
  };
};

const mapDispatchToProps = {
  disableCategory,
  enableCategory,
  disablePreset,
  enablePreset,
  showFavorites,
  showSearch,
};

export default connect(mapStateToProps, mapDispatchToProps)(Component);
